import { Config } from "../core/config/config";
import { Helper } from "../core/util/helper";
import { HTTPService, createHtppServiceInstance, JsonResultClass } from "../core/util/httpManager";
import { Commands } from "../core/util/commandManager";
import { DialogHelper } from "../core/util/dialogHelper";
import { Dialog, DialogProps } from "../core/components/dialog";
import { ComponentHelper } from "../core/util/componentHelper";
import { TextBox } from "../core/components/textBox";
import { EmailHelper } from "./emailHelper";
import { HtmlEditorProps } from "../core/components/htmlEditor";
import { StringKeyDictionary } from "../commonInterfaces";
import React from "react";
import ReactDOM from "react-dom";
export default class EmailEditor extends React.Component<EmailEditorProps, any>{
    private textAreaRef = null;
    private editorRef: kendo.ui.Editor = null;
    private previousReadOnlyState = false;
    private readOnlyState = false;
    private translations: StringKeyDictionary<string>;
    private tools: kendo.ui.EditorTool[];
    private factory = ComponentHelper.createFactory();

    constructor(props: EmailEditorProps) {
        super(props)
        this.readOnlyState = this.props.disabled;
        this.previousReadOnlyState = false;
        this.initApp();
    }

    private initApp = async () => {
        this.tools = this.getTools([
            'formatting', 'bold', 'italic', 'underline',
            'strikethrough', 'justifyLeft', 'justifyCenter',
            'justifyRight', 'justifyFull', 'insertUnorderedList',
            'insertOrderedList', 'indent', 'createLink',
            'foreColor', 'backColor', 'fontName',
            'fontSize', 'viewHtml',
        ]);
        console.log(this.tools)
        this.tools.splice(13, 0, {
            name: "uploadImage",
            exec: this.openImageDialog,
            template: `<button data-role="button" data-custom-function="uploadImage" class="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base k-icon-button k-toolbar-button k-toolbar-tool" type="button" role="button" aria-disabled="false" tabindex="-1">
                            <span class="k-svg-icon k-svg-i-link k-button-icon" aria-hidden="true">
                                <i class="fa-light fa-image"></i>
                            </span>
                       </button>`
        });
        this.tools.splice(14, 0, {
            name: "injectParameter",
            exec: this.openParameterDialog,
            template: `<button data-role="button" data-custom-function="injectParameter" class="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base k-icon-button k-toolbar-button k-toolbar-tool" type="button" role="button" aria-disabled="false" tabindex="-1">
                            <span class="k-svg-icon k-svg-i-link k-button-icon" aria-hidden="true">
                                <i class="fa-light fa-arrow-down-z-a"></i>
                            </span>
                       </button>`
        });
        this.setEvents();
        this.translations = await this.loadTranslations();
    }

    private loadTranslations = (): Promise<StringKeyDictionary<string>> => {
        const key = `htmlEditor_translations_${Config.user.languageId}`;
        const func = async () => {
            const keys = [
                "Standard.Components.HtmlEditor.InsertParameter",
                "Standard.Components.HtmlEditor.SelectSource",
                "Standard.Components.HtmlEditor.Database",
                "Standard.Components.HtmlEditor.StorageDevice",
                "WebCRM.Email.DataSource"
            ];
            const data = await createHtppServiceInstance().noBusyIndicator().post<JsonResultClass<StringKeyDictionary<string>>>("TranslationService/GetTranslations", { keys: keys });
            if (data.Code == 0) {
                return data.Data;
            } else {
                return null;
            }
        }

        return new Promise<StringKeyDictionary<string>>(async (resolve) => {
            let result = await EmailHelper.loadData(key, func);
            resolve(result)
        });
    } 

    private updateReadOnlyState = () => {
        if (this.readOnlyState !== this.previousReadOnlyState) {
            $(this.editorRef.body).attr("contenteditable", this.readOnlyState ? "false" : "true");
            if (this.readOnlyState) {
                const tmpEl = $("<input>");
                tmpEl.attr("readonly", "readonly");
                $("body").append(tmpEl);
                const bgColor = window.getComputedStyle(tmpEl[0]).backgroundColor;
                $(this.editorRef.body).css("background-color", bgColor);
                tmpEl.remove();
            } else {
                $(this.editorRef.body).css("background-color", "");
            }
            this.previousReadOnlyState = this.readOnlyState;
        }
    }

    private getTools = (names: Array<string>) => {
        const result: Array<kendo.ui.EditorTool> = [];

        if (Array.isArray(names)) {
            names.forEach(n => {
                result.push({ name: n });
            });
        }

        return result;
    }

    private setEvents = () => {
        this.props.commandManager.registerExecutor("htmlEditor", (command, data) => {
            if (command === Commands.REFRESH) {
                this.editorRef.refresh();
                this.updateReadOnlyState();
            }
        });
    }

    componentWillUnmount() {
        this.editorRef.destroy();
    }

    private setParameterFromSource = () => {
        const text = Helper.hasValue(this.translations) ? this.translations["Standard.Components.HtmlEditor.InsertParameter"] : "Enter parameter name";
        DialogHelper.prompt(text, "", 500).then((result) => {
            if (!Helper.isNullOrEmpty(result)) {
                const value = `<img src="{{{${result}}}}">`;
                this.injectHTML(value);
            }
        })
    }

    private uploadFileFromDrive = () => {
        Helper.uploadFile([], true).then((result) => {
            const value = `<img src="${result}">`;
            this.injectHTML(value);
        });
    }

    private injectHTML = (html: string) => {
        const storedRange = this.editorRef.getRange();
        this.editorRef.selectRange(storedRange);
        this.editorRef.exec("inserthtml", { value: html });
    }

    private openImageDialog = () => {
        const titelText = Helper.hasValue(this.translations) ? this.translations["Standard.Components.HtmlEditor.SelectSource"] : "Select source";
        const id = kendo.guid();

        const destroy = () => {
            ReactDOM.unmountComponentAtNode(targetElement[0]);
            targetElement[0].remove();
        }

        const dialogProps: DialogProps = {
            title: titelText,
            width: 600,
            actions: [],
            closable: true,
            afterClose: destroy
        };

        const targetElement = $("<div>");
        $("body").append(targetElement);
        ReactDOM.render(
            <Dialog {...dialogProps} open={true} title={titelText}>
                <div className="emailEditor__dialog" id={id}>
                    <div onClick={() => { this.setParameterFromSource(); destroy(); }}>
                        <i className="fal fa-database fa-5x"></i>
                        <span>{Helper.hasValue(this.translations) ? this.translations["WebCRM.Email.DataSource"] : "Database"}</span>
                    </div>
                    <div onClick={() => { this.uploadFileFromDrive(); destroy(); }}>
                        <i className="fal fa-hdd fa-5x"></i>
                        <span>{Helper.hasValue(this.translations) ? this.translations["Standard.Components.HtmlEditor.StorageDevice"] : "Storage device"}</span>
                    </div>
                </div>
            </Dialog >, targetElement[0]);
    }

    private openParameterDialog = () => {
        const text = Helper.hasValue(this.translations) ? this.translations["Standard.Components.HtmlEditor.InsertParameter"] : "Enter parameter name";
        let parameter = "";
        const props = this.factory.getDefaultTextBoxProps();
        props.value = parameter;
        props.onChange = (_, value) => {
            parameter = value;
        }
        const dialogProps: DialogProps = {
            title: text,
            width: 500,
            actions: [
                {
                    action: () => { },
                    label: Config.translations.cancel
                    
                }, {
                    action: () => {
                        if (!Helper.isNullOrEmpty(parameter)) {
                            this.injectHTML(`{{{${parameter}}}}`);
                        }
                    },
                    label: Config.translations.ok,
                    primary: true
                }

            ],
            afterClose: () => {
                ReactDOM.unmountComponentAtNode(targetElement[0]);
                targetElement[0].remove();
            }
        };       
        const targetElement = $("<div>");
        $("body").append(targetElement);
        ReactDOM.render(
            <Dialog {...dialogProps} open={true} title={text}>
                    <TextBox {...props}/>
            </Dialog >, targetElement[0]);
    }

    componentDidMount() {
        this.editorRef = $(this.textAreaRef).kendoEditor({
            encoded: false,
            tools: this.tools,
            change: (event) => {
                this.props.onChange(this.props.field, event.sender.value());
            },
            stylesheets: [
                `${Config.baseUrl}Content/kendo_html_editor.css`
            ],
        }).data("kendoEditor");
        this.editorRef.value(this.props.value);
        try {
            //Für email sollen anstatt p tags br tags eingefügt werden
            (this.editorRef as any).tools.insertLineBreak.options.shift = false;
            (this.editorRef as any).tools.insertParagraph.options.shift = true;
        } catch {

        }
        

        const button_1 = document.querySelector("[data-custom-function='uploadImage']");
        button_1.addEventListener("click", this.openImageDialog) //injectParameter

        const button_2 = document.querySelector("[data-custom-function='injectParameter']");
        button_2.addEventListener("click", this.openParameterDialog) //
    }

    componentDidUpdate() {
        this.readOnlyState = this.props.disabled;
        this.editorRef.value(this.props.value);
        this.updateReadOnlyState();
    }

    render() {
        return (
            <div style={{ all: "initial"}}>
                <div style={{ height: "500px" }}>
                    <textarea ref={(r) => this.textAreaRef = r} style={{ height: "100%" }} />
                    <input type="text" name={this.props.field.model} required={this.props.required} style={{ display: "none" }}
                        value={Helper.hasValue(this.props.value) && this.props.value !== "" ? "x" : ""} data-label={this.props.field.name} onChange={() => { }} />
                </div>
                
            </div>
        );
    }
};

interface EmailEditorProps extends HtmlEditorProps {}
